<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <g class="cls-1">
      <line x1="52" y1="4" x2="52" y2="100" />
      <line x1="22" y1="6" x2="82" y2="6" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "HalfDoubleCrochetIcon"
};
</script>

<style scoped>
.cls-1 {
  stroke: currentColor;
  stroke-width: 6.4px;
  fill: none;
}
</style>
